/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BankruptcyChecklistResponse,
  ProblemDetails,
  SaveBankruptcyConsequencesRequest,
  SaveDangerousDebtsRequest,
  SaveSpecialDebtsRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    BankruptcyChecklistResponseFromJSON,
    BankruptcyChecklistResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SaveBankruptcyConsequencesRequestFromJSON,
    SaveBankruptcyConsequencesRequestToJSON,
    SaveDangerousDebtsRequestFromJSON,
    SaveDangerousDebtsRequestToJSON,
    SaveSpecialDebtsRequestFromJSON,
    SaveSpecialDebtsRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface GetBankruptcyChecklistRequest {
    clientId: string;
}

export interface SaveBankruptcyChecklistBankruptcyConsequencesRequest {
    clientId: string;
    saveBankruptcyConsequencesRequest: SaveBankruptcyConsequencesRequest;
}

export interface SaveBankruptcyChecklistDangerousDebtsRequest {
    clientId: string;
    saveDangerousDebtsRequest: SaveDangerousDebtsRequest;
}

export interface SaveBankruptcyChecklistSpecialDebtsRequest {
    clientId: string;
    saveSpecialDebtsRequest: SaveSpecialDebtsRequest;
}

/**
 * BankruptcyChecklistApi - interface
 * 
 * @export
 * @interface BankruptcyChecklistApiInterface
 */
export interface BankruptcyChecklistApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankruptcyChecklistApiInterface
     */
    getBankruptcyChecklistRaw(requestParameters: GetBankruptcyChecklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankruptcyChecklistResponse>>;

    /**
     */
    getBankruptcyChecklist(requestParameters: GetBankruptcyChecklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankruptcyChecklistResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveBankruptcyConsequencesRequest} saveBankruptcyConsequencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankruptcyChecklistApiInterface
     */
    saveBankruptcyChecklistBankruptcyConsequencesRaw(requestParameters: SaveBankruptcyChecklistBankruptcyConsequencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankruptcyChecklistResponse>>;

    /**
     */
    saveBankruptcyChecklistBankruptcyConsequences(requestParameters: SaveBankruptcyChecklistBankruptcyConsequencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankruptcyChecklistResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveDangerousDebtsRequest} saveDangerousDebtsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankruptcyChecklistApiInterface
     */
    saveBankruptcyChecklistDangerousDebtsRaw(requestParameters: SaveBankruptcyChecklistDangerousDebtsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankruptcyChecklistResponse>>;

    /**
     */
    saveBankruptcyChecklistDangerousDebts(requestParameters: SaveBankruptcyChecklistDangerousDebtsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankruptcyChecklistResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {SaveSpecialDebtsRequest} saveSpecialDebtsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankruptcyChecklistApiInterface
     */
    saveBankruptcyChecklistSpecialDebtsRaw(requestParameters: SaveBankruptcyChecklistSpecialDebtsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankruptcyChecklistResponse>>;

    /**
     */
    saveBankruptcyChecklistSpecialDebts(requestParameters: SaveBankruptcyChecklistSpecialDebtsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankruptcyChecklistResponse>;

}

/**
 * 
 */
export class BankruptcyChecklistApi extends runtime.BaseAPI implements BankruptcyChecklistApiInterface {

    /**
     */
    async getBankruptcyChecklistRaw(requestParameters: GetBankruptcyChecklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankruptcyChecklistResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getBankruptcyChecklist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/bankruptcy-checklist`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BankruptcyChecklistResponseFromJSON(jsonValue));
    }

    /**
     */
    async getBankruptcyChecklist(requestParameters: GetBankruptcyChecklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankruptcyChecklistResponse> {
        const response = await this.getBankruptcyChecklistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveBankruptcyChecklistBankruptcyConsequencesRaw(requestParameters: SaveBankruptcyChecklistBankruptcyConsequencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankruptcyChecklistResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveBankruptcyChecklistBankruptcyConsequences().'
            );
        }

        if (requestParameters['saveBankruptcyConsequencesRequest'] == null) {
            throw new runtime.RequiredError(
                'saveBankruptcyConsequencesRequest',
                'Required parameter "saveBankruptcyConsequencesRequest" was null or undefined when calling saveBankruptcyChecklistBankruptcyConsequences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/bankruptcy-checklist/bankruptcy-consequences`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveBankruptcyConsequencesRequestToJSON(requestParameters['saveBankruptcyConsequencesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BankruptcyChecklistResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveBankruptcyChecklistBankruptcyConsequences(requestParameters: SaveBankruptcyChecklistBankruptcyConsequencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankruptcyChecklistResponse> {
        const response = await this.saveBankruptcyChecklistBankruptcyConsequencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveBankruptcyChecklistDangerousDebtsRaw(requestParameters: SaveBankruptcyChecklistDangerousDebtsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankruptcyChecklistResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveBankruptcyChecklistDangerousDebts().'
            );
        }

        if (requestParameters['saveDangerousDebtsRequest'] == null) {
            throw new runtime.RequiredError(
                'saveDangerousDebtsRequest',
                'Required parameter "saveDangerousDebtsRequest" was null or undefined when calling saveBankruptcyChecklistDangerousDebts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/bankruptcy-checklist/dangerous-debts`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveDangerousDebtsRequestToJSON(requestParameters['saveDangerousDebtsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BankruptcyChecklistResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveBankruptcyChecklistDangerousDebts(requestParameters: SaveBankruptcyChecklistDangerousDebtsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankruptcyChecklistResponse> {
        const response = await this.saveBankruptcyChecklistDangerousDebtsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveBankruptcyChecklistSpecialDebtsRaw(requestParameters: SaveBankruptcyChecklistSpecialDebtsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankruptcyChecklistResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling saveBankruptcyChecklistSpecialDebts().'
            );
        }

        if (requestParameters['saveSpecialDebtsRequest'] == null) {
            throw new runtime.RequiredError(
                'saveSpecialDebtsRequest',
                'Required parameter "saveSpecialDebtsRequest" was null or undefined when calling saveBankruptcyChecklistSpecialDebts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/bankruptcy-checklist/special-debts`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveSpecialDebtsRequestToJSON(requestParameters['saveSpecialDebtsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BankruptcyChecklistResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveBankruptcyChecklistSpecialDebts(requestParameters: SaveBankruptcyChecklistSpecialDebtsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankruptcyChecklistResponse> {
        const response = await this.saveBankruptcyChecklistSpecialDebtsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
